/**
 * Where a VideoMail take recorded by the server-side recorder stands, as this
 * app can see it.
 *
 * The room only shows the recorder's session while it runs: pending while it
 * joins, on while it captures, then off. A take that was captured and has
 * ended is being saved (the recorder transcodes and uploads it, and the
 * server then reports it ready to review). Without this, the end of the
 * session made the control fall back to "Starting recording" until the file
 * arrived, or for ever if it never did.
 */
/** How long a press may wait for the recorder to be assigned before the take is called failed. */
export const VIDEOMAIL_RECORDER_ASSIGN_WAIT_MS = 20000;
/** How often the server is asked whether an ended take is ready to review. */
export const VIDEOMAIL_SAVE_POLL_MS = 5000;
/**
 * How long an ended take may take to become ready to review. The recorder
 * transcodes the file before it uploads it, which for a three-minute take on
 * the shared server can take a minute or more.
 */
export const VIDEOMAIL_SAVE_WAIT_MS = 180000;
export const TAKE_IDLE = { stage: 'idle' };
/**
 * Moves the take on from what the room shows now. Returns the previous value
 * when nothing changed, so it can drive React state directly.
 *
 * @param {ITakeProgress} previous - Where the take was.
 * @param {IObservedRecorder} observed - The recorder session in the room now.
 * @returns {ITakeProgress} Where the take is.
 */
export function advanceTake(previous, { capturing, sessionId }) {
    if (sessionId) {
        const sameSession = previous.sessionId === sessionId;
        // Once captured, a take stays captured until its session ends.
        if (capturing || (sameSession && previous.stage === 'capturing')) {
            return sameSession && previous.stage === 'capturing' ? previous : { sessionId, stage: 'capturing' };
        }
        return sameSession && previous.stage === 'arming' ? previous : { sessionId, stage: 'arming' };
    }
    if (previous.stage === 'capturing') {
        return { sessionId: previous.sessionId, stage: 'saving' };
    }
    // A recorder that ended before it captured anything recorded nothing
    // (the middleware reports that take as failed); there is nothing to save.
    return previous.stage === 'arming' ? TAKE_IDLE : previous;
}
